/**
 * Client for the merged recipient invitation inbox.
 */
export class InvitesApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async listInbox(options) {
        const params = new URLSearchParams();
        if (options?.bucket)
            params.set('bucket', options.bucket);
        if (options?.sort)
            params.set('sort', options.sort);
        if (options?.dir)
            params.set('dir', options.dir);
        if (options?.limit != null)
            params.set('limit', String(options.limit));
        if (options?.offset != null)
            params.set('offset', String(options.offset));
        if (options?.types && options.types.length > 0) {
            params.set('types', options.types.join(','));
        }
        const query = params.toString();
        return this.client.get(`/api/invites/inbox${query ? `?${query}` : ''}`);
    }
}
//# sourceMappingURL=invites-api.js.map